<template>
    <section class="breadcrumb-area">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <img class="breadcrumb-avatar" v-if="object.avatar"
                         :src="'/storage' + object.avatar.path.replace('original', 'preview_l')" :alt="object.name">
                    <h1 class="page-title">{{ object.name }}, <span class="city">{{ object.city.name }}</span></h1>
                    <div class="breadcrumb" v-if="type === 'pet'">
                        <ul class="breadcrumb-text d-flex">
                            <li class="breadcrumb-text__item">{{ object.gender === 'male' ? $store.getters.t('pet_info_gender_male') : $store.getters.t('pet_info_gender_female') }}</li>
                            <li class="breadcrumb-text__item" v-if="object.petAgeCategory">{{object.petAgeCategory.name }}</li>
                            <li class="breadcrumb-text__item">{{$store.getters.t('pet_info_size_label')}}: {{ objectSize }}</li>
                        </ul>
                    </div>
                    <div class="breadcrumb" v-if=" typeof +object.spentTotal === 'number'">
                        <ul class="breadcrumb-text d-flex">
                            <li class="breadcrumb-text__item">{{$store.getters.t('breadcrumbs_spent_total')}} <strong>{{object.spentTotal}} EUR</strong></li>
                        </ul>
                    </div>
                </div>
                <!-- end /.col-md-12 -->
            </div>
            <!-- end /.row -->
        </div>
        <!-- end /.container -->
    </section>
</template>

<script>
export default {
    name: "PetAndProjectBreadcrumbsComponent",
    props: ['object', 'type'],
    computed: {
        objectSize() {
            if (this.object.size) {
                switch (this.object.size) {
                    case 'PET_SIZE_BELOW_TO_KNEE':
                        return this.$store.getters.t('pet_size_below_knee');
                    case 'PET_SIZE_KNEE_DEEP':
                        return this.$store.getters.t('pet_size_knee_deep');
                    case 'PET_SIZE_ABOVE_THE_KNEE':
                        return this.$store.getters.t('pet_size_above_knee');
                }
            }

            return this.$store.getters.t('common_unknown');
        }
    }
}
</script>

<style lang="scss" scoped>



.breadcrumb-avatar {
    float: left;
    max-width: 120px;
    width: 100%;
    border-radius: 50%;
    margin-right: 30px;
}

.breadcrumb-text {
    flex-flow: row wrap;
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 15px;
    color: #fff;
}

.breadcrumb-text__item{
    position: relative;
    padding-right: 8px;
    padding-left: 11px;

    &::before{
        position: absolute;
        display: block;
        content: '';
        left: 0;
        top: 50%;
        width: 3px;
        height: 3px;
        background: #fff;
        border-radius: 50%;
        transform: translateY(-50%);
    }

    &::after{
        display: none;
    }

    &:first-child{
        padding-left: 0;

        &::before{
            display: none;
        }
    }
}

.city {
    font-size: 17px;
}

.breadcrumb-area .page-title {
    color: #fff;
    font-weight: 500;
    font-size: 30px;
    text-transform: capitalize;
    margin-top: 17px;
}

.breadcrumb-area .breadcrumb{
    padding-bottom: 5px;
}

@media screen and (max-width: 768px){
    .breadcrumb-avatar{
        float: unset;
        display: block;
        margin: 0 auto;
    }

    .breadcrumb-area .page-title{
        font-size: 22px;
        line-height: 1;
        text-align: center;
    }

    .breadcrumb-text{
        font-size: 14px;
        line-height: 20px;
        justify-content: center;
    }

    .breadcrumb-area .breadcrumb{
        text-align: center;
    }
}
</style>
